<template>
	<div v-if="(ratingsForm.stars && ratingsForm.stars !== '' && main) || areValesFromItem" class="booker-opinion">
		<div v-if="main" class="booker-opinion__google"><GlobalIcon name="google-icon" :height="16"></GlobalIcon></div>
		<v-divider v-if="main" vertical></v-divider>
		<div v-if="!main" class="booker-opinion__rating">{{ ratings ? ratings : ratingsForm.ratings }}</div>
		<div class="booker-opinion__stars">
			<GlobalRating
				:rating="ratings ? ratings : ratingsForm.stars"
				readonly
				colorFilled="var(--primary-color)"
				colorEmpty="var(--primary-color)"></GlobalRating>
		</div>
		<div v-if="!main" class="booker-opinion__google">Google</div>
		<nuxt-link v-if="(ratingsForm.url && main) || googleUrl" :to="googleUrl ? googleUrl : ratingsForm.url" target="_blank" @click.stop>
			<div class="booker-opinion__amount" :class="{ 'booker-opinion__amount--dark': main }">
				{{ countRatings ? countRatings : ratingsForm.ratingsCount }} {{ $t('components.booker.google_reviews.opinions') }}
			</div>
		</nuxt-link>
		<div v-else class="booker-opinion__amount">
			{{ countRatings ? countRatings : ratingsForm.ratingsCount }} {{ $t('components.booker.google_reviews.opinions') }}
		</div>
	</div>
</template>

<script lang="ts" setup>
const props = defineProps<{
	main?: boolean
	countRatings?: number
	ratings?: number | string
	googleUrl?: string
}>()

const ratingsForm = inject('ratingsForm')

const areValesFromItem = computed(() => {
	return !!props.countRatings && !!props.ratings && !!props.googleUrl
})
</script>

<style lang="scss">
@import './Opinion';
</style>
